<template>
  <footer class="modern-footer">
    <div class="footer-content">
      <div class="footer-main">
        <!-- Company Info -->
        <div class="company-info">
          <h3 class="brand-name">Shanrise</h3>
          <p class="tagline">Bimbingan Belajar Psikologi</p>
        </div>
      </div>

      <!-- Copyright Bar -->
      <div class="copyright-bar">
        <div class="copyright-text">
          © {{ new Date().getFullYear() }} Shanrise. All Rights Reserved.
        </div>
      </div>
    </div>
  </footer>
</template>

<style scoped>
.modern-footer {
  width: 100%;
  background: #f8fafc;
  border-top: 1px solid #e2e8f0;
  padding: 2rem 0;
  margin-top: auto;
}

.footer-content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1rem;
}

.footer-main {
  display: flex;
  justify-content: center;
  text-align: center;
  /* margin-bottom: 1.5rem; */
}

.company-info {
  max-width: 400px;
}

.brand-name {
  font-size: 1.5rem;
  font-weight: 700;
  color: #1e293b;
  margin-bottom: 0.5rem;
}

.tagline {
  color: #64748b;
  font-size: 0.95rem;
}

.copyright-bar {
  text-align: center;
  padding-top: 1.5rem;
  border-top: 1px solid #e2e8f0;
  color: #64748b;
  font-size: 0.9rem;
}

/* Responsive Design */
@media (max-width: 768px) {
  .modern-footer {
    padding: 1.5rem 0;
  }

  .company-info {
    max-width: 100%;
  }
}
</style>

<script>
export default {
  name: "ModernFooter",
};
</script>
